const DATA_TEST_IDS = {
  menuList: 'top-panel__profile-menu_menu-list',
} as const;

export default DATA_TEST_IDS;
